import * as React from 'react'

import type { IconProps } from './types'

const CurrencyDollar = React.forwardRef<SVGSVGElement, IconProps>(
  ({ color = 'currentColor', ...props }, ref) => {
    return (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width={15}
        height={15}
        fill="none"
        ref={ref}
        {...props}
      >
        <g
          stroke={color}
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth={1.5}
          clipPath="url(#a)"
        >
          <path d="M7.5 13.944a6.444 6.444 0 1 0 0-12.888 6.444 6.444 0 0 0 0 12.888" />
          <path d="M9.115 5.679c-.35-.83-1.051-1.017-1.581-1.017-.493 0-1.787.262-1.667 1.504.084.872.906 1.196 1.624 1.324s1.761.402 1.787 1.454c.021.888-.778 1.495-1.744 1.495-.923 0-1.565-.359-1.812-1.17M7.5 3.722v.94M7.5 10.44v.838" />
        </g>
        <defs>
          <clipPath id="a">
            <path fill="#fff" d="M0 0h15v15H0z" />
          </clipPath>
        </defs>
      </svg>
    )
  }
)
CurrencyDollar.displayName = 'CurrencyDollar'
export default CurrencyDollar
